import { graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import SwiperCore from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { useTheme } from "context/ThemeContext";

import { OpenDaySlide } from "./openDaySlide";

import "swiper/css/bundle";
import "swiper/css/navigation";

// install Swiper components
SwiperCore.use([Autoplay, Navigation]);

const OpenDay = ({ customMeetUps }) => {
  const { currentBrand } = useTheme();
  const swiperRef = useRef(null);
  //console.debug("debug - live ", meetUps.length);

  // meetUps
  const { meetUpCollection } = useStaticQuery(graphql`
    query {
      meetUpCollection: allWpMeetUp {
        nodes {
          ...WpMeetUpFragment
        }
      }
    }
  `);

  const meetUps =
    customMeetUps?.length > 0 ? customMeetUps : meetUpCollection?.nodes ?? [];

  if (meetUps?.length < 1) {
    return <></>;
  }

  return (
    <section
      id={"open-day-slides"}
      key={"open-day-slides-key"}
      className="!min-h-0"
    >
      <div className="w-full relative ">
        <div className="absolute top-0 right-0 left-0 bottom-0 z-0">
          {currentBrand === "people" ? (
            <StaticImage
              alt=""
              src={"../../../images/homepage/open_day_bg.png"}
              className="w-full object-center object-cover h-full"
            />
          ) : (
            <StaticImage
              alt=""
              src={"../../../images/homepage/open_day_bg_dark.png"}
              className="w-full object-center object-cover h-full"
            />
          )}
        </div>

        <div className="openday-swiper-container relative w-screen md:w-[calc(100vw-32px)] pb-5 md:pt-2">
          <Swiper
            ref={swiperRef}
            speed={1300}
            grabCursor={true}
            spaceBetween={15}
            loop={meetUps.length > 1}
            className="z-20"
            slidesPerView={1}
            centeredSlides={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
          >
            {meetUps &&
              meetUps?.length > 0 &&
              meetUps?.map((meetUp, index) => {
                const meetUpTitle = meetUp.title;
                const meetUpLocation = meetUp.acfMeetUps.meetupLocation;
                const meetupDate = meetUp.acfMeetUps.meetupDate;
                const meetupDateTime = meetUp.acfMeetUps.meetupDateTime;
                const meetupDescription = meetUp.acfMeetUps.meetupDescription;
                const meetupStaffMembers = meetUp.acfMeetUps.meetupStaffMembers;
                const meetupTargetUri = meetUp.uri;

                return (
                  <SwiperSlide key={index}>
                    <OpenDaySlide
                      index={index}
                      slideData={meetUps}
                      meetUpTitle={meetUpTitle}
                      meetUpLocation={meetUpLocation}
                      meetupDate={meetupDate}
                      meetupDateTime={meetupDateTime}
                      meetupDescription={meetupDescription}
                      meetupStaffMembers={meetupStaffMembers}
                      meetupDetailUri={meetupTargetUri}
                    />
                  </SwiperSlide>
                );
              })}
          </Swiper>

          <div
            className="swiper-button-prev rotate-180 !left-9 !w-11 h-11 after:hidden !hidden md:!block"
            onClick={() => swiperRef.current.swiper.slidePrev()}
          />

          <div
            className="swiper-button-next !right-9 !w-11 h-11 after:hidden !hidden md:!block"
            onClick={() => swiperRef.current.swiper.slideNext()}
          />
        </div>
      </div>
    </section>
  );
};

OpenDay.defaultProps = {
  customMeetUps: []
};

OpenDay.propTypes = {
  customMeetUps: PropTypes.array
};

export default OpenDay;
